/**
 * Quiet stand-in for a payload the API redacted on a managed-workflow run
 * (see `isManagedRunRedaction`) — shown instead of a JSON viewer that would
 * only display the placeholder object.
 */
export function ManagedRunRedactedNote() {
  return (
    <div
      className="t-xs t-secondary"
      data-testid="managed-run-redacted"
      style={{ padding: 'var(--sp-2) var(--sp-3)' }}
    >
      Data redacted — managed workflow (org-wide data)
    </div>
  );
}
